// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"95499238","453":"88a834ec","636":"d8ded5ec","787":"db13acc1"}[chunkId] + ".chunk.js";
};